import { Stack } from "@mui/material";
import Counter from "@/components/Counter";
import { useCampground } from "@/contexts/AppConfigContext";
import { useBookingContext } from "@/contexts/BookingContext";

export default function Guests() {
  const { state, actions } = useBookingContext();
  const { data: campgroundData } = useCampground();
  const persons = campgroundData.campground?.persons || [];

  return (
    <Stack spacing={{ xs: 2, sm: 3 }} sx={{ mx: { xs: 2, sm: 3 }, mb: { xs: 2, sm: 3 } }}>
      {persons.map((person) => (
        <Counter
          key={person.id}
          label={person.name}
          description={person.description}
          count={state.selectedPersons[person.id] || 0}
          onChange={(count) => {
            actions.setSelectedPersons({
              ...state.selectedPersons,
              [person.id]: count,
            });
          }}
          min={0}
          max={20}
        />
      ))}
    </Stack>
  );
}
